var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHongkongIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.145,
    height: 100.301,
    viewBox: "0 0 21.145 100.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19988",
    "data-name": "Group 19988",
    transform: "translate(-294.416 -521.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20700",
    "data-name": "Path 20700",
    d: "M301.366,241.661H290.845V200.481l10.521-8.093Zm-10.046-.474h9.572V193.352l-9.572,7.362Z",
    transform: "translate(3.849 373.309)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20701",
    "data-name": "Path 20701",
    d: "M316.138,241.661H305.617V192.388l10.521,8.093Zm-10.047-.474h9.572V200.715l-9.572-7.362Z",
    transform: "translate(-0.877 373.309)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20702",
    "data-name": "Path 20702",
    d: "M301.135,252.2l-4.927-6.688-4.926,6.579-.38-.285,5.013-6.694-5.041-6.843h10.166l4.721-6.305-4.794-6.666,10.321.077-4.938,6.6,4.951,6.883-4.849,6.366,4.923,6.586-.38.285-4.842-6.478Zm-4.629-7.085,4.636,6.292,4.715-6.19-4.709-6.3Zm4.938-6.6,4.712,6.3,4.553-5.978-4.658-6.477Zm-9.631.224,4.4,5.971,4.471-5.971ZM301.9,225.785l4.16,5.785,4.286-5.723Z",
    transform: "translate(3.84 362.78)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20703",
    "data-name": "Path 20703",
    d: "M290.942,245.214",
    transform: "translate(3.817 356.41)",
    fill: "#002173",
    stroke: "#002173",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12478",
    "data-name": "Rectangle 12478",
    width: 0.475,
    height: 24.729,
    transform: "matrix(0.583, -0.813, 0.813, 0.583, 294.793, 574.1)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20704",
    "data-name": "Path 20704",
    d: "M291.223,214.8l-.255-.4,9.537-6.078-9.62-6.686L310.951,187.1V172.971L300.9,180.332V150.569l10.521,7.549v14.436l.047.035-.047.035v14.719l-19.719,14.291,9.657,6.711Zm10.156-49.188V179.4l9.3-6.811Zm.373-.314,9.2,6.894V158.7Zm-.373-13.809v13.493l9.4-6.747Z",
    transform: "translate(3.836 386.686)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12479",
    "data-name": "Rectangle 12479",
    width: 0.474,
    height: 13.45,
    transform: "translate(304.74 524.268)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12480",
    "data-name": "Rectangle 12480",
    width: 0.474,
    height: 17.583,
    transform: "translate(307.342 522)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20705",
    "data-name": "Path 20705",
    d: "M306.188,149.548l-.26-.4,2.5-1.635.26.4Z",
    transform: "translate(-0.977 387.663)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20706",
    "data-name": "Path 20706",
    d: "M311.413,266.951H290.845v-2.728h20.568Zm-20.093-.474h19.618V264.7H291.32Z",
    transform: "translate(3.849 350.33)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20707",
    "data-name": "Path 20707",
    d: "M311.413,272.762H290.845v-5.125h20.568Zm-20.093-.475h19.618v-4.176H291.32Z",
    transform: "translate(3.849 349.238)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19935",
    "data-name": "Group 19935",
    transform: "translate(297.344 618.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12481",
    "data-name": "Rectangle 12481",
    width: 0.475,
    height: 1.765,
    transform: "translate(0 0)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12482",
    "data-name": "Rectangle 12482",
    width: 0.475,
    height: 1.765,
    transform: "translate(2.491 0.022)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12483",
    "data-name": "Rectangle 12483",
    width: 0.475,
    height: 1.765,
    transform: "translate(4.981 0.044)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12484",
    "data-name": "Rectangle 12484",
    width: 0.475,
    height: 1.765,
    transform: "translate(7.472 0.065)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12485",
    "data-name": "Rectangle 12485",
    width: 0.475,
    height: 1.765,
    transform: "translate(9.962 0.087)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12486",
    "data-name": "Rectangle 12486",
    width: 0.475,
    height: 1.765,
    transform: "translate(12.453 0.109)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12487",
    "data-name": "Rectangle 12487",
    width: 0.474,
    height: 1.765,
    transform: "translate(14.943 0.131)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12488",
    "data-name": "Rectangle 12488",
    width: 0.539,
    height: 4.651,
    transform: "translate(304.708 617.112)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20708",
    "data-name": "Path 20708",
    d: "M310.553,271.2H293.024v-2.24h17.529Zm-17.053-.474h16.579v-1.291H293.5Z",
    transform: "translate(3.151 348.815)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20709",
    "data-name": "Path 20709",
    d: "M311.646,265.8H294.117v-1.659h17.529Zm-17.055-.474h16.58v-.711h-16.58Z",
    transform: "translate(2.802 350.357)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12489",
    "data-name": "Rectangle 12489",
    width: 20.245,
    height: 0.474,
    transform: "translate(294.869 619.575)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12490",
    "data-name": "Rectangle 12490",
    width: 0.687,
    height: 0.687,
    transform: "translate(295.717 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12491",
    "data-name": "Rectangle 12491",
    width: 0.687,
    height: 0.687,
    transform: "translate(297.623 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12492",
    "data-name": "Rectangle 12492",
    width: 0.687,
    height: 0.687,
    transform: "translate(299.528 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12493",
    "data-name": "Rectangle 12493",
    width: 0.687,
    height: 0.687,
    transform: "translate(301.435 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12494",
    "data-name": "Rectangle 12494",
    width: 0.687,
    height: 0.687,
    transform: "translate(303.341 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12495",
    "data-name": "Rectangle 12495",
    width: 0.687,
    height: 0.687,
    transform: "translate(305.684 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12496",
    "data-name": "Rectangle 12496",
    width: 0.687,
    height: 0.687,
    transform: "translate(307.495 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12497",
    "data-name": "Rectangle 12497",
    width: 0.687,
    height: 0.687,
    transform: "translate(309.307 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12498",
    "data-name": "Rectangle 12498",
    width: 0.687,
    height: 0.687,
    transform: "translate(311.118 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12499",
    "data-name": "Rectangle 12499",
    width: 0.687,
    height: 0.687,
    transform: "translate(312.93 620.389)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19936",
    "data-name": "Group 19936",
    transform: "translate(296.919 614.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12500",
    "data-name": "Rectangle 12500",
    width: 0.475,
    height: 1.164,
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12501",
    "data-name": "Rectangle 12501",
    width: 0.475,
    height: 1.164,
    transform: "translate(3.411 0.017)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12502",
    "data-name": "Rectangle 12502",
    width: 0.475,
    height: 1.164,
    transform: "translate(6.822 0.034)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12503",
    "data-name": "Rectangle 12503",
    width: 0.475,
    height: 1.164,
    transform: "translate(10.233 0.052)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12504",
    "data-name": "Rectangle 12504",
    width: 0.475,
    height: 1.164,
    transform: "translate(13.644 0.069)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12505",
    "data-name": "Rectangle 12505",
    width: 0.474,
    height: 1.164,
    transform: "translate(17.055 0.086)",
    fill: "#002173",
    stroke: "#002173",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20710",
    "data-name": "Path 20710",
    d: "M320.871,227.526",
    transform: "translate(-5.756 362.068)",
    fill: "#002173",
    stroke: "#002173",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHongkongIcon);
export default __webpack_public_path__ + "static/media/hongkong_icon.b1d4e847ded9b84b1d93f3359d4eca8a.svg";
export { ForwardRef as ReactComponent };